import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

import { ProjectModule } from './types';
import { RootModule } from '../root-module';
import { ProjectStatus } from '@/types/crm-types';
import { DisplayOptions } from '@/types/store-types';

const namespaced = true;

const defaultOptions = (): DisplayOptions => {
  if (localStorage.displayOptions) {
    const value = localStorage.displayOptions;
    return JSON.parse(value) as DisplayOptions;
  }

  return {
    showWeekend: true,
    hourlyRate: false,
    startDate: false,
    endDate: false,
    plannedTotal: true,
  };
};

export const state: ProjectModule = {
  projectData: {
    projectId: '',
    projectName: '',
    customer: '',
    owner: '',
    startDate: new Date(),
    status: ProjectStatus.Completed,
    isClosed: true,
    url: '',
  },
  categories: [],
  tasks: [],
  weeks: [],
  days: [],
  displayOptions: defaultOptions(),
  selectedTasks: [],
  employees: [],
  employeeList: [],
  holidays: [],
};

export const project: Module<ProjectModule, RootModule> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
